<template>
  <CheckboxBase>
    <input type="checkbox"
      :id="id"
      :value="value"
      :text="text"
      v-model="input"
      :disabled="isDisabled">
    <label :for="id">
      <span class="ico_brand ico_checkbox"></span>
      {{ text }}
      <slot/>
    </label>
  </CheckboxBase>
</template>

<script>
import CheckboxBase from './CheckboxBase'

export default {
  name: 'CheckboxItem',
  components: {
    CheckboxBase
  },
  props: {
    id: String || Object,
    text: String,
    value : Object,
    checkedNames: Array,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    input: {
      get() {
        return this.checkedNames;
      },
      set(value) {
        this.$emit("update:checkedNames", value);
      }
    }
  }
}
</script>
